// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../../graphql/api/index';

export const FooterItemTextFragmentDoc = `
    fragment footerItemText on FooterColumnItemText {
  text
}
    `;